import {DownloadOutlined, LoadingOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import "src/pages/applications/download-files/download-files.scss"
import {fetchSignedUrlForDownload} from "../../pages/applications/applicationList/service";
import {downloadFileBasedOnLink} from "../../common/utils/file-utils";
import {Tooltip} from "antd";
import {ReviewAction, sendReviewEvent} from "../matomoClient";

type FileProps = {
    fileNameSpace: string,
    fileCategory: string,
    fileName: string,
}

type MatomoProps = {
    reviewName: String | null,
    sectionName: String | null
}

type Props = {
    file: FileProps | null
    displayName: string
    matomo: MatomoProps | null
}

export function DownloadFile(props: Props) {
    const [isLoading, setIsLoading] = useState<boolean>(false)

    async function onDownloadIconClick() {
        if (props.file === null) {
            return
        }
        setIsLoading(true)
        sendReviewEvent(
            ReviewAction.DownloadReviewFiles,
            `${props.displayName} under ${props.matomo?.sectionName} section of ${props.matomo?.reviewName ?? props.file.fileNameSpace}`
        )
        await fetchSignedUrlForDownload(props.file!!.fileNameSpace, props.file!!.fileCategory, props.file!!.fileName)
            .then(({signedUrl}: { signedUrl: string }) => {
                downloadFileBasedOnLink(signedUrl)
            }).finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <div className="downloadable-file">
            <div className="file-category">{props.displayName}</div>
            <div>
                <Tooltip placement="top" title={props.file ? null : "Not Available"}>
                    <div className={props.file ? "file-download-icon" : "file-download-icon-disabled"}>
                        {isLoading ?
                            <LoadingOutlined className="loading-icon"/> :
                            <DownloadOutlined
                                className={"download-icon"}
                                onClick={onDownloadIconClick}
                            />
                        }
                    </div>
                </Tooltip>
            </div>
        </div>
    )
}